import { render, staticRenderFns } from "./ProjectLanguageAutocomplete.vue?vue&type=template&id=46f41a28&"
import script from "./ProjectLanguageAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ProjectLanguageAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports